import { render, staticRenderFns } from "./SitePriceForm.vue?vue&type=template&id=f056bfe0"
import script from "./SitePriceForm.vue?vue&type=script&lang=js"
export * from "./SitePriceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports